import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import classnames from 'classnames';
import * as React from 'react';

import { IHeaderViewProps } from './gh-header';

const headerView: React.FC<IHeaderViewProps> = props => {
    const { HeaderTag, HeaderContainer, HeaderTopBarContainer, Divider } = props;
    return (
        <Module {...HeaderTag}>
            <Node {...HeaderContainer}>
                <Node {...HeaderTopBarContainer}>
                    {props.navIcon}
                    {props.logo}
                    {_renderReactFragment(props.search)}
                    {props.preferredStore}
                    {_renderAccountBlock(props, false)}
                    {props.wishListIconDesktop}
                    <Node {...Divider} />
                    {props.cartIcon}
                    {_renderReactFragment(props.siteOptions)}
                </Node>
                <Node className='gh-header__desktop-view'>{_renderReactFragment(props.menuBar)}</Node>
            </Node>
            {_renderMobileOverlay(props)}
        </Module>
    );
};

// ─── Mobile menu overlay (full-screen, slides in from left) ──────

function _renderMobileOverlay(props: IHeaderViewProps): JSX.Element {
    const isOpen = !props.mobileMenuCollapsed;
    return (
        <div
            className={classnames('gh-mobile-menu', { 'gh-mobile-menu--open': isOpen })}
            aria-hidden={!isOpen}
            onClick={e => {
                // Close on backdrop click (not panel)
                if (e.target === e.currentTarget) {
                    props.toggleMobileMenu();
                }
            }}
        >
            <div className='gh-mobile-menu__panel'>
                <div className='gh-mobile-menu__top'>
                    {props.logo}
                    <button className='gh-mobile-menu__close' onClick={props.toggleMobileMenu} aria-label='Stäng meny' type='button'>
                        <span aria-hidden='true'>&times;</span>
                    </button>
                </div>
                <div className='gh-mobile-menu__body'>{_renderReactFragment(props.menuBar)}</div>
            </div>
        </div>
    );
}

// ─── Account block (desktop topbar) ─────────────────────────────

function _renderAccountBlock(props: IHeaderViewProps, renderForMobile: boolean): JSX.Element | null {
    const {
        AccountInfoDropdownParentContainer,
        AccountInfoDropdownPopoverConentContainer,
        accountInfoDropdownButton,
        signOutLink,
        signInLink,
        accountLinks
    } = props;

    if (AccountInfoDropdownParentContainer) {
        const accountClassName = classnames(
            AccountInfoDropdownParentContainer.className,
            renderForMobile ? 'account-mobile' : 'account-desktop'
        );
        if (AccountInfoDropdownPopoverConentContainer) {
            return (
                <Node {...AccountInfoDropdownParentContainer} className={accountClassName}>
                    {accountInfoDropdownButton}
                    <Node {...AccountInfoDropdownPopoverConentContainer}>
                        {accountLinks ? accountLinks.map((link: React.ReactNode) => link) : false}
                        {signOutLink}
                    </Node>
                </Node>
            );
        } else if (signInLink) {
            return (
                <Node {...AccountInfoDropdownParentContainer} className={accountClassName}>
                    {signInLink}
                </Node>
            );
        }
    }

    return null;
}

// ─── Helpers ─────────────────────────────────────────────────────

function _renderReactFragment(items: React.ReactNode[]): JSX.Element | null {
    return (
        <>
            {items && items.length > 0
                ? items.map((slot: React.ReactNode, index: number) => {
                      return <React.Fragment key={index}>{slot}</React.Fragment>;
                  })
                : null}
        </>
    );
}

export default headerView;
